import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const LogOutIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M3 6C3 4.34315 4.34315 3 6 3H9C10.6569 3 12 4.34315 12 6V7C12 7.55228 11.5523 8 11 8C10.4477 8 10 7.55228 10 7V6C10 5.44772 9.55228 5 9 5H6C5.44772 5 5 5.44772 5 6V18C5 18.5523 5.44772 19 6 19H9C9.55228 19 10 18.5523 10 18V17C10 16.4477 10.4477 16 11 16C11.5523 16 12 16.4477 12 17V18C12 19.6569 10.6569 21 9 21H6C4.34315 21 3 19.6569 3 18V6ZM15.3356 6.75259C15.7484 6.38567 16.3805 6.42285 16.7474 6.83564L20.7474 11.3356C21.0842 11.7145 21.0842 12.2855 20.7474 12.6644L16.7474 17.1644C16.3805 17.5771 15.7484 17.6143 15.3356 17.2474C14.9229 16.8805 14.8857 16.2484 15.2526 15.8356L17.7732 13H9C8.44772 13 8 12.5523 8 12C8 11.4477 8.44772 11 9 11H17.7732L15.2526 8.16436C14.8857 7.75158 14.9229 7.11951 15.3356 6.75259Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

LogOutIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(LogOutIcon);
